import { BaseWebComponentController } from '../../../../../../framework/BaseWebComponentController';
import { TargetsGridWebComponent } from '../component/TargetsGridWebComponent';
import { TargetsGridView } from '../view/TargetsGridView';
import { templateTargetsGrid } from '../view/template';

export class TargetsGridController extends BaseWebComponentController {
  constructor(component: TargetsGridWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: TargetsGridView,
      viewTemplate: templateTargetsGrid,
    });
  }
}
